module.exports = __webpack_public_path__ + "static/media/sign-in.48cf6906.svg";